import { ApiPagination } from '@/types';

export namespace SoftwareLicenses {
  export enum Pages {
    SOFTWARE_LICENSES = 'software_licenses',
    SOFTWARE_LICENSE_DETAIL = 'software_license'
  }

  export type SoftwareLicense = {
    [key: string]: unknown,
    id?: string | number,
    organization_name: string,
    client_name: string,
    client_type: string,
    client_contact: string,
    client_email: string,
    client_phone: string,
    client_inn: string,
    client_kpp: string,
    client_country: string,
    client_region: string,
    client_city: string,
    nomenclature: string,
    license_key: string,
    client_date_activation: string,
    client_date_expired: string,
    status: {
      name: string,
      slug: string
    },
    doc: string,
    client_shop: string,
    client_device: string,
    product_id?: number,
    has_detail: boolean,
    is_available_add_cart: boolean,
    serial_prolonged: string,
    date_prolonged: string,
  };

  export type NotActiveSoftwareLicense = {
    nomenclature: string,
    serial_number: string,
    purchase_date: string,
    activation_deadline: string,
    status: {
      name: string,
      color: string
    }
  };

  export interface NotActiveSoftwareLicenseStatusItem {
    name: string,
    color: string,
  }

  export interface NotActiveSoftwareLicensesFilters {
    statuses: NotActiveSoftwareLicenseStatusItem[]
  }

  export interface NotActiveSoftwareLicensesRequestFilters {
    [key: string]: unknown,
    search: string | null,
    statuses: number[] | null
  }

  export interface NotActiveSoftwareLicensesResponse extends ApiPagination {
    data: {
      items: NotActiveSoftwareLicense[],
      filters: NotActiveSoftwareLicensesFilters,
    }
  }
}

export interface SoftwareLicenseHistory {
  id: number
  organization_name: string
  client_name: string
  client_type: string
  client_contact: string
  client_email: string
  client_phone: string
  client_inn: string
  client_kpp: string
  client_country: string
  client_region: string
  client_city: string
  nomenclature: string
  license_key: string
  doc: string
  client_shop: string
  client_device: string
  activation_at: string
  expired_at: string
  status: {
    name: string,
    slug: string
  },
}

export interface SoftwareCartHistory {
  id: number
  order_id: number
  order_external_number: string
  order_date: string
  order_status: string
  cart_history_id: number
  cart_history_date: string
  cart_history_external_number: string
}

export interface SoftwareLicensesFilters {
  [key: string]: unknown,
  statuses?: string[],
  search?: string;
  cities?: null | string[];
  dates: string[];
}

export interface SoftwareLicensesStatuses {
  slug: string,
  name: string,
}

export interface SoftwareLicenseCategories {
  [key: string]: unknown,
  id: number,
  name_category: string
}

export enum SoftwareLicensesChipStatuses {
  ACTIVE = 'active',
  EXPIRING_SOON = 'expiring_soon',
  EXPIRED = 'expired',
  ARCHIVE = 'archive'
}
